export const SomethingWentWrong = 'Something went wrong. Please try again.';
export const SuccessMessage = (action) => `Success! ${action} has been created`;
export const SuccessSchedulerAssignedMessage = 'Success! Scheduler has been assigned';
export const SuccessOperatorNoteMessage = 'Success! Operator note added successfully';
export const SuccessOperatorNoteRemoveMessage = 'Success! Operator note removed successfully';
export const SuccessStatusChangedMessage = 'Success! Status has been changed';
export const SuccessSchedulerUnassignMessage = 'Success! Scheduler has been unassigned';
export const SuccessAllSchedulerUnassignMessage = 'Success! All schedulers have been unassigned';
export const SuccessLinkLegMessage = 'Legs successfully linked';
export const SuccessPriorityMessage = 'Success! Priority has been assigned';
export const SuccessSchedulerSubStatusMessage = (action = '') => `Success! Sub-status has been ${action ? action : 'assigned'}`;
export const UpdateSuccessMessage = (action) => `Success! ${action} has been updated`;
export const DeletedSuccessMessage = (action) => `Success! ${action} has been deleted`;
export const CommonSuccessMessage = 'Changes Saved';
export const SuccessAmenitiesUpdatedMessage = 'Amenities Updated Successfully!';
export const AlreadyExistsMessage = (action) => `${action} already exists!`;
export const TripIDCopiedMessage = 'Trip ID copied';
export const DeletePopupModalDescription = 'Are you sure you want to delete this? This action cannot be undone.';
export const CancelModalPopupDescription = 'Do you want to cancel? Any unsaved data will be lost.';
export const BackToPreviousDescritpion = 'Do you want to leave the page? Any unsaved data will be lost.';
export const DeletePopupModalDesc = 'Are you sure you want to delete this? This action cannot be undone.';
export const DeletePopupModalCommon = 'Are you sure you want to delete this file? This action cannot be undone.';
export const DeleteScenarioModalCommon = 'Are you sure you want to delete this scenario? This action cannot be undone.';
export const DeleteScenarioOperatorMessage = 'Are you sure you want to delete this? This action cannot be undone.';
export const DeleteNoteModal = 'Are you sure you want to permanently delete this note from the system?';
/**
 * scheduler_sub_status ids, as the API returns them — SchedulerSubStatusDto.id is an Integer,
 * so these are numbers, not strings.
 *
 * Behaviour and display key off these rather than off scheduler_sub_status.status. The label is
 * a DB column the business can rename at any time, and every `status === 'Matchup'` comparison
 * would then stop matching with no error. Ranking still comes from the `priority` column on the
 * same response (see filterDataByHighestPriority), which is the DB's to own.
 */
export const SUB_STATUS_ID = {
  ACTIVE: 1,
  INACTIVE: 2,
  CX: 3,
  MATCHUP: 4,
  MX: 5,
  QUEUE: 6,
  NEW: 7,
  ATTENTION_NEEDED: 8,
};


export const TRIP_TYPE = {
  CHARTER: '1',
  JET_CARD: '2',
};

export const AIRCRAFT_TYPE = {
  PISTON: { id: 1, type: 'Piston' },
  TURBO_PROP: { id: 2, type: 'Turbo Prop' },
  VLJ: { id: 3, type: 'VLJ' },
  LIGHT: { id: 4, type: 'Light' },
  MID: { id: 5, type: 'Mid' },
  SUPER_MID: { id: 6, type: 'Super Mid' },
  HEAVY: { id: 7, type: 'Heavy' },
  OTHER: { id: 8, type: 'Other' },
};

export const AIRCRAFT_TYPE_LIST = Object.values(AIRCRAFT_TYPE);

export const SCENARIO_TYPE = {
  SPLIT: 'Split',
  COMBINED: 'Combined',
};

export const SCENARIO_ORIGIN = {
  BROKER_REQUESTED: '1',
  BROKER_CREATED: '2',
  SCHEDULER_CREATED: '3',
  CLIENT_ACCEPTED: '4',
};

export const DATASOURCE = {
  AVINODE: 1,
  MAVERICK: 2,
  MANUAL: 3,
  NBAA: 4,
};

// Mirrors phoenix-be's avinode.enableTripCancellation. While that is off, a
// cancel request does nothing, so the Trip Cancel button stays hidden.
export const IS_AVINODE_TRIP_CANCEL_ENABLED = process.env.REACT_APP_FEATURE_ENABLED_AVINODE_TRIP_CANCEL === 'true';
